import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ConfirmationService } from "primeng/api";
import { NotificationTypes } from "src/app/app.enums";
import { InstagramAccountsApiResponce } from "src/app/models/socialpost.model";
import { ResponseObject } from "src/app/Services/auth.service";
import { InstagramService } from "src/app/Services/instagram.service";
import { NotificationsService } from "src/app/Services/shared/notifications.service";
import { TranslocoService } from "@jsverse/transloco";

@Component({
    selector: 'instagram-account',
    templateUrl: './instagram-account.component.html',
    standalone: false
})

export class InstagramAccountComponent implements OnInit {
    public instagramAccount: InstagramAccountsApiResponce[] = [];

    constructor(
        private ngxSpinnerService: NgxSpinnerService,
        private confirmationService: ConfirmationService,
        private notificationsService: NotificationsService,
        private router: Router,
        private instagramService: InstagramService,
        private transloco: TranslocoService) {

    }

    ngOnInit(): void {
        this.getConnectedInstagramAccounts();
    }

    public getConnectedInstagramAccounts(): void {
        this.ngxSpinnerService.show();
        this.instagramService.onGetAllInstagramAccounts(true).subscribe({
            next: (response: InstagramAccountsApiResponce[]) => {
                this.instagramAccount = response || [];
                this.ngxSpinnerService.hide();
            },
            error: (error) => {
                console.error('Error fetching accounts:', error);
                this.ngxSpinnerService.hide();
                this.notificationsService.showNotification(this.transloco.translate('instagramAccount.errorTitle'), this.transloco.translate('instagramAccount.fetchFailed'), NotificationTypes.Error);
            }
        });
    }

    public onConnectInstagramAccount() {
        this.ngxSpinnerService.show();
        this.instagramService.onloginWithInstagram().subscribe((responce: ResponseObject) => {
            if (responce.Success) {
                window.location.href = responce.ResponseData;
                this.ngxSpinnerService.hide();
            }
        }, (error) => { console.error(error), this.ngxSpinnerService.hide(); })
    }

    public onDeactivateInstagramAccount(Id: string) {
        const instagramAccount = this.instagramAccount.find((instagramAccount) => instagramAccount.Id == Id)
        this.confirmationService.confirm({
            message: this.transloco.translate('instagramAccount.deactivateConfirm', { userName: instagramAccount?.UserName }),
            accept: () => {
                this.ngxSpinnerService.show();
                this.instagramService.onDeactiveAccount(Id).subscribe((response) => {
                    this.ngxSpinnerService.hide();
                    if (response.Success) {
                        var index = this.instagramAccount.findIndex(p => p.Id == Id)
                        if (index !== -1) {
                            this.instagramAccount.splice(index, 1)
                            // this.isSocialAccountConnected = false
                        }
                        this.notificationsService.showNotification(this.transloco.translate('instagramAccount.successTitle'), this.transloco.translate('instagramAccount.deactivatedSuccess'), NotificationTypes.Success);
                    } else { this.notificationsService.showNotification(this.transloco.translate('instagramAccount.errorTitle'), response.ResponseMessage, NotificationTypes.Error); }
                }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.notificationsService.showNotification(this.transloco.translate('instagramAccount.errorTitle'), this.transloco.translate('instagramAccount.deactivateError'), NotificationTypes.Error); });
            },
        });
    }

    public deleteAllCaaounts() {
        this.router.navigate(['/delete-meta'], { queryParams: { platform: 'instagram' } });
    }

}